export default "<div class=\"tooltip-holder\">\n  <div class=\"tooltip\">\n    <span class=\"tooltiptext right\">{{ tooltipText }}</span>\n  </div>\n</div>\n"